<ul class="unordered-with-price--padding-inline-start">
  <li class="unordered-with-price--li-marker feature-detail-second-color" *ngFor="let item of featureListWithPrice">
    <div class="o-flex o-flex--justify-space-between">
      <span>{{item.name}}</span>
      <span class="u-color-red-faded">{{item.currencyName}} {{item.price}} /user /mo</span>
    </div>
  </li>
</ul>
